import { useController } from 'react-hook-form';

import { FormValues } from '../types';
import { UsePollList } from './types';

const usePollList = <T extends FormValues>({ control, name }: UsePollList<T>) => {
  const { field } = useController({ control, name });
  const { value } = field;

  const selectedPollId: MongoId | null = value ? (value as MongoId) : null;

  return { selectedPollId };
};

export default usePollList;
